import {makeAction, makeAsyncAction} from 'common/utils/simplifiedAsync';

const ACTION_PREFIX = 'anodot/admin.activityLog/';
const mac = (actionName) => makeAction(actionName, ACTION_PREFIX);
const macAsync = (actionName) => makeAsyncAction(actionName, ACTION_PREFIX);

export const updateFilterBtn = mac('UPDATE_FILTER_BTN');
export const fetchAuditLog = macAsync('FETCH_AUDIT_LOG');
export const displayActivitySnackBar = mac('DISPLAY_ACTIVITY_SNACK_BAR');
